import type { EventExport as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';
import type { GuestListImportStatus } from './GuestListImportStatus';

/** The latest CSV import into a guest list; its status is derived by the server and only ever read here. */
export type GuestListImport = {
  id: number;
  status: GuestListImportStatus;
  /** Rows the import read; null until it finishes. */
  rowCount: number | null;
  /** Rows the import rejected; null until it finishes. */
  errorCount: number | null;
  /** Presigned per-row result, minted per read; null unless the import is ready. */
  downloadUrl: string | null;
};

export const fromGql = (item: GQLItem): GuestListImport =>
  take<GuestListImport>(item, 'id', 'status', 'rowCount', 'errorCount', 'downloadUrl');
